export default function BrandIcon({ size = 32, className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={`shrink-0 ${className}`}
      role="img"
      aria-label="MachinePilot"
    >
      <rect x="1.5" y="1.5" width="97" height="97" rx="20" fill="#14181c" stroke="#3a434d" strokeWidth="3" />
      <circle cx="50" cy="50" r="6" fill="#ffffff" />
      <path d="M50 50 L50 16" stroke="#ffffff" strokeWidth="10" strokeLinecap="round" />
      <path
        d="M80 50C80 66.57 66.57 80 50 80C38.7 80 28.8 73.6 24 64.2"
        stroke="#e8590c"
        strokeWidth="12"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="24" cy="64.2" r="9" fill="#e8590c" />
    </svg>
  );
}
